import React, { useState, useRef, useEffect } from "react";
import styles from "./BingSearchButton.module.css";

interface Props {
  onChange: (isEnabled: boolean) => void;
  initialState?: boolean;
  disabled?: boolean; // 非活性化するためのプロパティを追加
}

export const BingSearchButton: React.FC<Props> = ({ onChange, initialState = true, disabled = false }) => {
  const [isEnabled, setIsEnabled] = useState<boolean>(initialState);

  useEffect(() => {
    setIsEnabled(initialState);
  }, [initialState]);

  const handleButtonClick = () => {
    if (disabled) return; // 非活性状態の場合は何もしない

    const newState = !isEnabled;
    setIsEnabled(newState);
    onChange(newState); // 親コンポーネントに状態を通知（フラグ値としては newState ? 1 : 0）
  };

  return (
    <div className={styles.bingSearchButton}>
      <button
        onClick={handleButtonClick}
        className={`${styles.toggleButton} ${isEnabled ? styles.enabled : styles.disabledState} ${disabled ? styles.isDisabled : ''}`}
        aria-label={`Bing検索 ${isEnabled ? "オン" : "オフ"}`}
        aria-pressed={isEnabled}
        disabled={disabled}
        title={disabled ? "RAG検索インデックスが選択された状態でBingSearch検索は使用できません" : "BingSearch検索"}
      >
        <span className={styles.label}>{isEnabled ? "Bing Search" : "Bing Search"}</span>
        <span className={`${styles.knob} ${isEnabled ? styles.knobRight : styles.knobLeft}`} aria-hidden="true" />
      </button>
    </div>
  );
};
